var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"label":_vm.label,"data-vv-name":_vm.id,"value":_vm.value},on:{"input":_vm.handleChange}},'v-text-field',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }